import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=47419991&"
import script from "./Ranking.js?vue&type=script&lang=js&"
export * from "./Ranking.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports